<child-header title="Edit Promo Image" (closeEvent)="onNoClick()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content>
    <input class="file-upload" type='file' (change)="onSelectFile($event)">
  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-mid" (click)="saveBlockContent()">Save</button>
    <button mat-button class="button button-red button-mid" (click)="onNoClick()">Cancel</button>
  </div>
</div>
